import NiceModal from '@ebay/nice-modal-react';
import { ActionIcon, Group, Table, Text } from '@mantine/core';
import { IconEdit, IconTrash } from '@tabler/icons-react';

import { useRemoveService } from '../../api/removeService';
import { serviceTypes } from '../../types';
import { EditModal } from '../EditModal';

import { ConfirmModal } from '@/components/Modals/Confirm';
import { Departments } from '@/types';

type BodyRowProps = {
  department: Departments;
  service: serviceTypes.Service;
};

export const BodyRow = ({ department, service }: BodyRowProps) => {
  const removeService = useRemoveService({ department });
  const { _id, name, key } = service;

  return (
    <Table.Tr>
      <Table.Td>
        <Text size="sm">{name}</Text>
      </Table.Td>
      <Table.Td>
        <Text size="sm">{key}</Text>
      </Table.Td>
      <Table.Td>
        <Group>
          <ActionIcon
            variant="filled"
            radius="md"
            onClick={() =>
              NiceModal.show(EditModal, {
                serviceId: _id,
                initialValues: { name, key, department },
              })
            }
          >
            <IconEdit size={16} />
          </ActionIcon>
          <ActionIcon
            variant="filled"
            radius="md"
            color="red"
            onClick={() =>
              NiceModal.show(ConfirmModal, {
                title: `Remove service (${name})?`,
                onSuccess: () => removeService.mutate({ _id }),
              })
            }
          >
            <IconTrash size={16} />
          </ActionIcon>
        </Group>
      </Table.Td>
    </Table.Tr>
  );
};
